import "@/styles/base.scss";
import React, { FC, useEffect, useState } from "react";
import { GoalsLoader } from "@/apps/goals/components/GoalsLoader/GoalsLoader";
import {
  ModeTabsPortal,
  ModeTabsProvider,
} from "@/app/components/ModeTabs/ModeTabsPortal";
import { Outlet, useLocation } from "react-router-dom";
import { BonusPopupController } from "@/apps/raffle/components/BonusPopupController/BonusPopupController";
import { useStartupParamsStore } from "@/store/startupParams";
import { useVersionCheck } from "@/utils/hooks/useVersionCheck";
import { useAppPreload } from "./useAppPreload";
import cls from "./styles.module.scss";

export const App: FC = () => {
  const location = useLocation();
  const { pathname, search } = location;
  const [transitionVariant, setTransitionVariant] = useState<"a" | "b">("a");
  const isPreloading = useAppPreload(search);
  useVersionCheck();

  const initializeFromSearch = useStartupParamsStore(
    (state) => state.initializeFromSearch
  );

  useEffect(() => {
    initializeFromSearch(search);
  }, [initializeFromSearch, search]);

  useEffect(() => {
    setTransitionVariant((current) => (current === "a" ? "b" : "a"));
  }, [pathname]);

  if (isPreloading) {
    return <GoalsLoader />;
  }

  return (
    <ModeTabsProvider>
      <div className={cls.wrapper}>
        <div className={cls.container}>
          <ModeTabsPortal />
          <div
            className={
              transitionVariant === "a"
                ? cls.pageTransitionVariantA
                : cls.pageTransitionVariantB
            }
          >
            <Outlet />
          </div>
          <BonusPopupController />
        </div>
      </div>
    </ModeTabsProvider>
  );
};
